import { producaov2 } from './apis';
import { getNodeToken } from './auth_node';

const auth = () => ({
  headers: { access_token: `voitto-token ${getNodeToken()}` },
});

export const listCompanies = (search = '') =>
  producaov2.get(`/admin/certificate-companies?search=${encodeURIComponent(search)}`, auth());

export const createCompany = ({ name, color, logoFile }) => {
  const form = new FormData();
  form.append('name', name);
  if (color) form.append('color', color);
  if (logoFile) form.append('logoFile', logoFile);
  return producaov2.post('/admin/certificate-companies', form, auth());
};

export const updateCompany = (id, { name, color, logoFile }) => {
  const form = new FormData();
  form.append('name', name);
  if (color) form.append('color', color);
  if (logoFile) form.append('logoFile', logoFile);
  return producaov2.put(`/admin/certificate-companies/${id}`, form, auth());
};

export const listBatches = ({ search = '', page = 1 } = {}) =>
  producaov2.get(
    `/admin/certificate-batches?search=${encodeURIComponent(search)}&page=${page}`,
    auth()
  );

export const createBatch = (data) => producaov2.post('/admin/certificate-batches', data, auth());
export const getBatch = (id) => producaov2.get(`/admin/certificate-batches/${id}`, auth());
export const updateBatch = (id, data) =>
  producaov2.put(`/admin/certificate-batches/${id}`, data, auth());
export const duplicateBatch = (id) =>
  producaov2.post(`/admin/certificate-batches/${id}/duplicate`, {}, auth());

export const parseEmenta = (payload) =>
  producaov2.post('/admin/certificate-batches/parse-ementa', payload, auth());

export const parseStudents = (id, { text, file }) => {
  if (file) {
    const form = new FormData();
    form.append('file', file);
    return producaov2.post(`/admin/certificate-batches/${id}/parse-students`, form, auth());
  }
  return producaov2.post(`/admin/certificate-batches/${id}/parse-students`, { text }, auth());
};

export const saveStudents = (id, students) =>
  producaov2.post(`/admin/certificate-batches/${id}/students`, { students }, auth());
export const removeStudent = (id, sid) =>
  producaov2.delete(`/admin/certificate-batches/${id}/students/${sid}`, auth());

export const processBatch = (id) =>
  producaov2.post(`/admin/certificate-batches/${id}/process`, {}, auth());
export const getBatchStatus = (id) =>
  producaov2.get(`/admin/certificate-batches/${id}/status`, auth());
export const generateStudent = (id, sid) =>
  producaov2.post(`/admin/certificate-batches/${id}/students/${sid}/generate`, {}, auth());
export const sendEmails = (id, studentIds = null) =>
  producaov2.post(`/admin/certificate-batches/${id}/send-emails`, { studentIds }, auth());

export const exportBatch = async (id, title = 'turma') => {
  const response = await producaov2.get(`/admin/certificate-batches/${id}/export`, {
    ...auth(),
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = `certificados-${title}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
